type ReliabilitySegmentDotProps = {
  activeDotIndices?: Set<number>;
  index?: number;
  cx?: number;
  cy?: number;
  stroke?: string;
};

export const ReliabilitySegmentDot = ({
  stroke,
  cx,
  cy,
  activeDotIndices,
  index,
}: ReliabilitySegmentDotProps) => {
  if (index === undefined || !activeDotIndices?.has(index)) {
    return null;
  }

  return (
    <circle
      cx={cx}
      cy={cy}
      r={3}
      fill="white"
      stroke={stroke}
      strokeWidth={2}
    />
  );
};
